import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";

const Ewallet = Loadable(
  lazy(() => import("src/pages/admin/financial/ewallet"))
);
const DepositWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/deposit"))
);
const LatestSales = Loadable(
  lazy(() => import("src/pages/admin/financial/sales/index"))
);
const FundCredits = Loadable(
  lazy(() => import("src/pages/admin/financial/fundCredit"))
);
const Payout = Loadable(
  lazy(() => import("src/pages/admin/financial/payout/payout"))
);
const FinancialReport = Loadable(
  lazy(() =>
    import("src/pages/admin/financial/financialReport/financialReport")
  )
);

const PendingWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/pending/index"))
);
const EduPointWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/edu-point-wallet/index"))
);
const UpWallet = Loadable(
  lazy(() => import("src/pages/admin/financial/up-wallet/index"))
);

const financial = [
  {
    path: "financial",
    children: [
      { element: <Navigate to="e-wallet" />, index: true },
      { path: "e-wallet", element: <Ewallet /> },
      { path: "deposit-wallet", element: <DepositWallet /> },
      { path: "edu-point-wallet", element: <EduPointWallet /> },
      { path: "up-wallet", element: <UpWallet /> },
      { path: "pending-wallet", element: <PendingWallet /> },
      { path: "fund-credits", element: <FundCredits /> },
      { path: "payout", element: <Payout /> },
      { path: "report", element: <FinancialReport /> },
      { path: "sales", element: <LatestSales /> },
    ],
  },
];

export default financial;
